module.exports = __webpack_public_path__ + "static/img/102765.2798c94f.png";